module.exports = __webpack_public_path__ + "img/elementwidths_jas.b208bcb5.png";